import { ActionPermissionModal, CrossButton, CustomSelect, CustomTable, Customdropdown, Heading } from 'components';
import { UserContext } from 'context';
import { API, axiosInstance } from 'lib';
import { EbillExtentionModal, EditTripOffCanvas, RoutePanningModal } from 'modals';
import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import { constant } from 'constants/constant';
import './companyCanvas.css'
import { LuUserRound } from 'react-icons/lu';
import { TbBuilding } from 'react-icons/tb';
import { FaRegStar } from 'react-icons/fa6';
import { GoCheckCircleFill } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
import StorageService from 'utils/StorageServices';
import { debounce, truncate } from 'lodash';
import toast from 'react-hot-toast';
import { Offcanvas } from 'react-bootstrap';
import { getCompanyCheck } from '_services';

const CompanyCanvas = ({ handleCompanyName, setOpen, open }) => {
  const {
    setShowCreateCompanyModal,
    userData,
    setGlobCompanyId,
    settingChild,
    setDashboardFilterClear,
    setWarningDetails
  } = React.useContext(UserContext);

  const settingChildRoles = settingChild?.find((i) => i?.label === "Company");
  const navigate = useNavigate();
  const company_id = StorageService.getCompanyId();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [company, setCompany] = useState();

  // Fix 1: Remove internal state management, use props directly
  // const [showCompanyCanvas, setShowCompanyCanvas] = useState(open || false);

  useEffect(() => {
    setCompany(company_id);
  }, [company_id]);

  // Fix 2: Initialize filteredItems properly
  useEffect(() => {
    if (userData?.user_detail?.company_list) {
      setFilteredItems(userData.user_detail.company_list);
    }
  }, [userData?.user_detail?.company_list]);



  // Debounced function to handle the search input change
  const debouncedHandleSearch = useMemo(
    () =>
      debounce((term) => {
        if (!userData?.user_detail?.company_list) return;

        if (term === "") {
          setFilteredItems(userData.user_detail.company_list);
        } else {
          const filtered = userData.user_detail.company_list.filter((item) =>
            item?.company_id?.company?.toLowerCase().includes(term.toLowerCase())
          );
          setFilteredItems(filtered);
        }
      }, 300),
    [userData?.user_detail?.company_list]
  );

  const handleSearch = useCallback(
    (event) => {
      const term = event.target.value;
      setSearchTerm(term);
      debouncedHandleSearch(term);
    },
    [debouncedHandleSearch]
  );

  const handlechangeComany = (item) => {
    StorageService.setCompanyId(item?.company_id?._id);
    handleCompanyName(item?.company_id?._id);
    setCompany(item?.company_id?._id);
    setGlobCompanyId(item?.company_id?._id);

    navigate("/dashboard");
    setDashboardFilterClear(true);
    toast.success(
      `Change Into Company "${item.company_id.company.toUpperCase()}"`
    );

    // Close the canvas after selection
    handleClose();
  };

  // Fix 3: Improved close handler
  const handleClose = () => {
    setSearchTerm(""); // Clear search when closing
    if (setOpen) {
      setOpen(false);
    }
  };

  // Fix 4: Add click handler for "Add New Company"
  const handleAddNewCompany = () => {
    if (settingChildRoles?.create) {
      createCompanyCheck()
    } else {
      toast.error("You don't have permission to create a company");
    }
  };


  const createCompanyCheck = async () => {
    try {
      // setOpen(false)
      // setShowCreateCompanyModal(true);

      const res = await getCompanyCheck()

      if (res?.responseCode == 200) {
          setOpen(false)
        setShowCreateCompanyModal(true);
      } else {
        // toast.error(res?.responseCode)
      }

    } catch (error) {

    }
  }

  return (
    <Offcanvas
      show={open} // Fix 5: Use prop directly instead of internal state
      onHide={handleClose}
      placement="end"
      backdrop={true} // Fix 6: Enable backdrop (remove static)
      keyboard={true} // Fix 7: Enable keyboard ESC to close
      className="__nwCompany_offCanva"
      scroll={false}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          Company
          <CrossButton
            type="button"
            className="_switchBtn __animEffect_btn"
            style={{ marginLeft: 'auto' }}
            onClick={handleClose}
          >
            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path
                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                fill="black"
              />
            </svg>
          </CrossButton>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className='__cmplTx_bxs'>
          <h6>My Company List</h6>
          <button
            className='anime-btn'
            onClick={handleAddNewCompany}
            disabled={!settingChildRoles?.create}
          >
            Add New Company
          </button>
        </div>

        <div className="msc_inputContain mt-0">
          <input
            type="text"
            placeholder="Search Organisation"
            value={searchTerm} // Fix 8: Connect search input
            onChange={handleSearch}
          />
        </div>

        <div className='__cmpList_mainBx'>
          {/* Fix 9: Dynamic rendering of company list */}
          {filteredItems && filteredItems.length > 0 ? (
            filteredItems.map((item, index) => (
              <div
                key={item?.company_id?._id || index}
                className={`__cmpList_vwn ${company === item?.company_id?._id ? '__activeCmpl' : ''}`}
                onClick={() => handlechangeComany(item)}
                style={{ cursor: 'pointer' }}
              >
                <div className='__cmpBuilds'>
                  <TbBuilding />
                </div>

                <div className='__cmpDetail_ls'>
                  <h6>{item?.company_id?.company || 'Unknown Company'}</h6>
                  <p>Organisation ID: {item?.company_id?.company_code || 'N/A'}</p>

                  <div className='__ownFree_bxs'>
                    <span className='__ownFr_tag'>
                      <span><LuUserRound /></span>
                      {item?.role_id?.role_name || 'Member'}
                    </span>
                    <span className='__freeFr_tag'>
                      <span><FaRegStar /></span>
                      {item?.company_id?.subscription_data?.plan_type || 'Free Plan'}
                    </span>
                  </div>
                </div>

                {company === item?.company_id?._id && (
                  <div className='__cmpCheck_ic'>
                    <GoCheckCircleFill />
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="text-center py-4">
              <p>No companies found</p>
            </div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default CompanyCanvas